import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import * as z from "zod/v4";

export {
  barcodeLabelSize,
  type BarcodeLabelSize,
} from "@redotech/redo-model/inventory/barcode-label";

export const generateLicensePlate = {
  name: "generateLicensePlate" as const,
  input: z.object({
    returnItemId: z.string().min(1),
    upc: z.string().optional(),
    sku: z.string().optional(),
    productTitle: z.string().optional(),
    variantTitle: z.string().optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    labelSize: z.enum(barcodeLabelSize).optional(),
  }),
  output: z.object({ pdfBase64: z.string(), printed: z.boolean().optional() }),
};
